const consola = require('consola')

const logger = consola.withScope('TAMS:log')

export default (ctx, inject) => {
  const getDevOptions = () => {
    try {
      return JSON.parse(localStorage.getItem('mkkdev'))
    } catch (e) {
      return false
    }
  }

  // TAMS
  const isDevMode = () => {
    let
      devMode = false,
      frontendDebug = false
    const devOptions = getDevOptions()

    if (typeof devOptions.debug !== 'undefined') {
      frontendDebug = Boolean(devOptions.debug)
    }
    try {
      devMode = window.$nuxt.$store.state.common.common.uiData.system.dev_mode === 1
    } catch (e) {}
    return devMode || frontendDebug
  }

  const logs = (...args) => {
    try {
      if (isDevMode()) {
        logger.warn(...args)
      }
    } catch (e) {}
  }

  ctx.$log = logs

  inject('log', logs)
}
